import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App as AntdApp } from 'antd';
import App from './app/app.js';
import '@digiwedge/ui-antd/index.css';
import './styles.css';

try {
  const current =
    (globalThis as unknown as { importMetaEnv?: Record<string, unknown> }).importMetaEnv || {};
  (globalThis as unknown as { importMetaEnv?: Record<string, unknown> }).importMetaEnv = {
    ...current,
    VITE_IDP_BASE_URL: import.meta.env['VITE_IDP_BASE_URL'],
    VITE_IDP_AUDIENCE: import.meta.env['VITE_IDP_AUDIENCE'],
    VITE_YOLO_API_URL: import.meta.env['VITE_YOLO_API_URL'],
  } as Record<string, unknown>;
} catch {
  // ignore if not in a browser context
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <BrowserRouter>
      <AntdApp>
        <App />
      </AntdApp>
    </BrowserRouter>
  </StrictMode>,
);
